import {
    PREDICTION_HISTOGRAM_DRAW_BAR,
    PREDICTION_HISTOGRAM_DRAW_PAINT,
    HISTOGRAM_CHART,
    SCATTERPLOT_CHART,
    PREDICTION,
    PARALLEL_COORDINATES_CHART,
    ACTUAL,
    SEEDATA,
    COMBINED,
    COMBINEDSTACKEDBARCHART,
    BAR_CHART,
    LINE_CHART,
    COMBINEDGROUPBARCHART,
    PREDICTION_HISTOGRAM_CANVAS_CLEAR,
    PREDICTION_HISTOGRAM_CANVAS_PENCIL
} from "../../Canvas/Constants";
import {
    histogramPredictionDataset,
    HistogramPrediction,
    BrushingDataSet,
    brushingDataset,
    PredictionPointsLineChart
} from "../../../Globals/Globals";
import { GraphPredictContext } from "../../Canvas/GraphPredictContext";
import * as React from "react";
import { extent as d3ArrayExtent, histogram, range as d3Range } from "d3-array";
import { axisBottom as d3AxisBottom, axisLeft as d3AxisLeft } from "d3-axis";
import { min as d3min, max as d3max } from "d3";
import {
    scaleLinear as d3ScaleLinear,
    scaleTime as d3ScaleTime,
    scalePoint as d3ScalePoint,
    scaleOrdinal as d3ScaleOrdinal,

} from "d3-scale";
import * as d3 from "d3";
import { schemeCategory10 as d3SchemeCategory10, event as d3event } from "d3";

import {
    select as d3Select,
    selectAll as d3SelectAll,
    event as d3event1
} from "d3-selection";
import { line as d3Line } from "d3-shape";

import * as aggregation from "../../aggregation/countAggregation";
import { func } from "prop-types";
import { useState } from "react";
import * as interactfuncs from "../../../libtsx/interactfuncs";

import { histogramBrush } from "../../Brushing/HistogramBrush";
import { scatterPlotBrush } from "../../Brushing/ScatterPlotBrush";
import { lineChartBrush } from "../../Brushing/LineChartBrush";
import { parallelCoordinatesPlotBrush } from "../../Brushing/ParallelCoordinatesBrush";
import { barChartBrush } from "../../Brushing/BarChartBrush";

import CombinedToolBox from "../../Canvas/CombinedToolBox";
import { PREDICTION_COLOR, REALDATA_COLOR, BRUSHING_COLOR, NO_PREDICTION_COLOR } from "../../../Globals/ColorConstants"
import {clearAllBrushes} from '../../Canvas/MasterGraphConfig'
import {LogEvents} from '../../../Globals/Globals'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
    ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, LOG_EVENT_TYPE_CHART_BRUSHING_STARTED} from '../../../Globals/LogConstants'
    

    
interface LineChartStates { }

interface LineChartProps {
    id: string;
    xaxis: string;
    yaxis: string;
    height: number;
    width: number;
    brushValueOptions: {}
}

const LineChart: React.FC<LineChartProps> = ({ id, width, height, xaxis, yaxis }) => {
    
    const { grapVisOptions, setgrapVisOptions } = GraphPredictContext();

  

    
    console.log(
        "GraphPredictContextHistogram",
        grapVisOptions,
        histogramPredictionDataset
    );
    var graphDraw = grapVisOptions["graphDraw"];
    var grapCanvasOptions = grapVisOptions["grapCanvasOptions"];
    var grapCanvasClearToggle = grapVisOptions["grapCanvasClearToggle"];
    var graphOptions = grapVisOptions["graphOptions"];
    var graphType = grapVisOptions["graphType"];
    var graphbrushEnable = grapVisOptions["graphbrushEnable"];
    console.log('categoriesCount categoriesCount', xaxis, aggregation.loadValues, aggregation.loadValues1)
    var categoriesCount: Array<number> = aggregation.loadValues[xaxis];
   

    var categoriesMap = {};
    var categoriesMapAverage = {};

    var categoriesSave = {}

    var margin = { top: 10, right: 10, bottom: 60, left: 40 };
    var height = height - margin.left - margin.right;
    var width = width - margin.top - margin.bottom;
    console.log("categoriesMap", categoriesMap);
    var xScaleBand
    var xAxis
    var linearYScale
    var yAxis
    var xScaleLinear
    var rectForeground: any = "";
    var lineDataValues
    var linedraw
    var domainMax
    var categoriesValueMap = new Map<string,number>();
    categoriesCount.map(function(d, i) {
        if (categoriesMap[d] == null) {
            categoriesMap[d] = 1;
            categoriesSave[d] = 1;
           
        } else {
            categoriesMap[d] = categoriesMap[d] + 1;
            categoriesSave[d] = categoriesSave[d] + 1;
        }
    });

   
         
    if (yaxis != 'Count') {

   
       var categoriesValues = aggregation.loadValues1;
          categoriesValues.map(function(d, i) {
            var category = d[xaxis]
            var value = d[yaxis]
            if (categoriesValueMap[category] == null) {
              categoriesValueMap[category] =  value ;
             
            } else {
              categoriesValueMap[category] = value + categoriesValueMap[category];
           
            }
          });

      Object.keys(categoriesMap).map(function(e) {
        categoriesMap[e] = categoriesValueMap[e] / categoriesMap[e]
         })
    }

        const parseTime = d3.timeParse('%Y');
        var lineData = []
              
        if (yaxis != 'Count') {
            var dateValues = Object.keys(categoriesValueMap)
        }
        else
        {
            var dateValues = Object.keys(categoriesMap)
        }
        for (var i = 0; i < dateValues.length; i++) {
            lineData.push([new Date(dateValues[i]), categoriesMap[dateValues[i]]])
        }

        lineDataValues = lineData.map((d) => {
            return {
                date: parseTime(d[0]),
                value: d[1],
            };
        });
      console.log('minyear',d3.min(d3.extent(Object.keys(categoriesMap), d => new Date(d).getFullYear())))
        xScaleLinear = d3ScaleTime()
            .domain(
                [d3.min(d3.extent(Object.keys(categoriesMap), d => new Date(d).getFullYear())),
                d3.max(d3.extent(Object.keys(categoriesMap), d => new Date(d).getFullYear()))
                ]
            )
          
            
            .range([0, width])
         
           


        xAxis = d3AxisBottom(xScaleLinear)
        domainMax = d3.max(
          Object.keys(categoriesMap).map(function(e) {
            return categoriesMap[e];
        }))
        
        domainMax = domainMax + domainMax*0.1
        linearYScale = d3
            .scaleLinear()
            .domain([
                0,
                domainMax
            ])
            .nice()
            .range([height, 0]);

        yAxis = d3AxisLeft(linearYScale);
        console.log('xScaleTime', xScaleLinear)
        console.log('extent', d3.min(d3.extent(Object.keys(categoriesMap), d => new Date(d).getFullYear())))
        console.log('extent', d3.max(d3.extent(Object.keys(categoriesMap), d => new Date(d).getFullYear())))
    

    console.log(
        'yAxis', yAxis,
        'xAxis', xAxis,
    )


    if (brushingDataset.getActualID(id) == null) {
        var actualDataset = brushingDataset.addActualID(id)
        actualDataset.type = LINE_CHART
      
        actualDataset.setlinearYScale(linearYScale)
        actualDataset.setlinearXScale(xScaleLinear)
        actualDataset.categoriesMap = categoriesMap
        actualDataset.setSumCategories(categoriesSave)
        actualDataset.domainMax = domainMax
        actualDataset.xaxis = xaxis
        actualDataset.yaxis = yaxis
        actualDataset.width = width
        actualDataset.height = height
        actualDataset.xAxis = xAxis
        actualDataset.yAxis = yAxis
    }
    else {
      
        brushingDataset.getActualID(id).type = LINE_CHART
        brushingDataset.getActualID(id).xaxis = xaxis
        brushingDataset.getActualID(id).yaxis = yaxis
        brushingDataset.getActualID(id).width = width
        brushingDataset.getActualID(id).height = height
        brushingDataset.getActualID(id).categoriesMap = categoriesMap
        brushingDataset.getActualID(id).setlinearXScale(xScaleLinear)
        brushingDataset.getActualID(id).setlinearYScale(linearYScale)
        brushingDataset.getActualID(id).setSumCategories(categoriesSave)
        brushingDataset.getActualID(id).domainMax = domainMax
        brushingDataset.getActualID(id).xAxis = xAxis
        brushingDataset.getActualID(id).yAxis = yAxis
    }

    console.log('brushingScatterPlotDataset.getActualID(id)', brushingDataset.getActualMap())
    console.log('LineChart')
    var graph: any = "";




    React.useEffect(() => {
        console.log("useEffectBarChart");
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);
        console.log("useEffectBarChart", BrushingDataSet.currentGraphType,graphOptions, )
        console.log(graphType, graphDraw, grapCanvasOptions, graphOptions);

      
        if (
            graphOptions == '' 
          )
          {

          }
        if (
            graphOptions == SEEDATA 
          )
          {
                
              if(BrushingDataSet.currentGraphType == HISTOGRAM_CHART)
              {
                
                histogramBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == SCATTERPLOT_CHART)
              {
                
                scatterPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == BAR_CHART)
              {
                
                barChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == LINE_CHART)
              {
                
                lineChartBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData, brushingDataset);
              }
              if(BrushingDataSet.currentGraphType == PARALLEL_COORDINATES_CHART)
              {
                
                parallelCoordinatesPlotBrush(BrushingDataSet.currentGraphEnable, BrushingDataSet.currentGraphID, BrushingDataSet.currentGraphData);
              }
              
            
          }
    }, [graphType, graphOptions, width, height]);
    
    if (
        graphOptions == ''
    ) {
        return (
            <>
                {""}
                <svg
                    className={id + "chart"}
                    id={id + "_svg_barchart_draw"}
                    height={height + margin.left + margin.right}
                    width={width + margin.top + margin.bottom}
                  
                >
                    <g
                        transform={"translate(" + margin.left + ", " + margin.top + ")"}
                        id={id + "_svg_linechart"}
                    >
                        <g transform={"translate(0," + height + ")"}>
                            <g
                                transform={"translate(0,0)"}
                                ref={node => d3Select(node).call(xAxis)}
                            ></g>
                        </g>
                     
                        <g ref={node => d3Select(node).call(yAxis)} className={"axisY"}>


                        </g>
                    </g>
                </svg>
            </>
        )
    }
    if (
        graphOptions == PREDICTION
    ) {

       

            var predictionPoints
            if (histogramPredictionDataset.getPredictionLineChart(id + "_lineChart") == null) {
                predictionPoints = histogramPredictionDataset.addPredictionLineChart(id + "_lineChart")
            }
            else {
                predictionPoints = histogramPredictionDataset.getPredictionLineChart(id + "_lineChart")
            }
            console.log('predictionPoints', predictionPoints)
            var dateValues = Object.keys(categoriesMap)
            var lineDataFilter1 = []
            var lineDataFilter2 = []
            var j=2
            var singledateValue
            for (var i = 0; i < dateValues.length; i++) {

                if(i == j)
                {
                    singledateValue = dateValues[i-1]
                    lineDataFilter2.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }

                /*if (new Date(dateValues[i]).getFullYear() == 1973) {
                    lineDataFilter2.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }*/

                if(i<=j)
                {
                    lineDataFilter1.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }
                else
                {
                    lineDataFilter2.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }

               /* if (new Date(dateValues[i]).getFullYear() <= 1973) {
                    lineDataFilter1.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                } else {
                    lineDataFilter2.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }
                */
            }
            var yourData = lineDataFilter2
                .map(function(d) { return { xValue: d[0], yValue: d[1], defined: false } })
                .filter(function(d) {
                    if (d.xValue == singledateValue) d.defined = true
                    return d.xValue >= singledateValue
                })
            var line = d3.area()
                .x(function(d) { return xScaleLinear(d[0]); })
                .y(function(d) { return linearYScale(d[1]); });


            console.log('lineData', yourData, lineDataFilter1, lineDataFilter2)
            var linePreData = <path
                fill={'none'}
                d={line(lineDataFilter1)}
                stroke={REALDATA_COLOR}
                strokeWidth={2}
            ></path>
            var lineDataPre
            var predictionPathLineChart
            if (predictionPoints && predictionPoints.predictedPath) {
                var linefn = d3.line<{ xValue: number; yValue: number; defined: boolean }>()
                    .defined(d => d.defined)
                    .x(function(d) { return xScaleLinear(d.xValue); })
                    .y(function(d) { return linearYScale(d.yValue); });
                predictionPathLineChart = <path id={id + "_pre_line_path"} className={"your-line"} fill={'none'}
                    d={linefn(predictionPoints.predictedPath)}
                    stroke={PREDICTION_COLOR}
                    strokeWidth={2}
                    strokeDasharray={5} ></path>
                lineDataPre = [...predictionPoints.predictedPath]
            }
            else {
                predictionPathLineChart = <path id={id + "_pre_line_path"} className={"your-line"} fill={'none'}

                    stroke={PREDICTION_COLOR}
                    strokeWidth={2}
                    strokeDasharray={5} ></path>
                lineDataPre = [...yourData]
            }

            console.log('yourDataSel pos', yourData, singledateValue)
            var dragLine = d3.drag()
                .on('start', function(){
                    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                    if(logevents)
                    { 
                        var eventlog = LogEvents.addEvent(id, LINE_CHART, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED,null, null,xaxis,yaxis,null)
                        logevents._logEvents.push(eventlog)
                        sessionStorage.setItem('logevents', JSON.stringify(logevents))
                    }
                })
                .on('drag', function() {
                    var x = d3.event.x
                    var y = d3.event.y

                    var xValue = clamp(dateValues.indexOf(singledateValue)+1, dateValues[dateValues.length-1], xScaleLinear.invert(x))
                    var yValue = clamp(0, linearYScale.domain()[1], linearYScale.invert(y))

                    lineDataPre.forEach(function(d) {

                        if (Math.abs(d.xValue - xValue) < 0.8) {
                            d.yValue = yValue
                            d.defined = true
                        }
                    })

                    var linefn = d3.line<{ xValue: number; yValue: number; defined: boolean }>()
                        .defined(d => d.defined)
                        .x(function(d) { return xScaleLinear(d.xValue); })
                        .y(function(d) { return linearYScale(d.yValue); });

                    d3.select('#' + id + "_pre_line_path").attr('d', linefn(lineDataPre));
                    predictionPoints.predictedPath = lineDataPre

                })
                .on('end', function(){


                    var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
                    if(logevents)
                    { 
                        var eventlog = LogEvents.addEvent(id, LINE_CHART, PREDICTION, LOG_EVENT_TYPE_CHART_PREDICTION_ENDED,lineDataPre, null,xaxis,yaxis,null)
                        logevents._logEvents.push(eventlog)
                        sessionStorage.setItem('logevents', JSON.stringify(logevents))
                    }
                })

            return (
                <>
                    {""}
                    <svg
                        className={id + "chart"}
                        id={id + "_svg_barchart_draw"}
                        height={height + margin.left + margin.right}
                        width={width + margin.top + margin.bottom}
                        ref={node => d3Select(node).call(dragLine)}
                    >
                        <g
                            transform={"translate(" + margin.left + ", " + margin.top + ")"}
                            id={id + "_svg_linechart"}
                        >
                            <g transform={"translate(0," + height + ")"}>
                                <g
                                    transform={"translate(0,0)"}
                                    ref={node => d3Select(node).call(xAxis)}
                                ></g>
                            </g>
                            {linePreData}
                            {predictionPathLineChart}
                            <g ref={node => d3Select(node).call(yAxis)} className={"axisY"}>


                            </g>
                        </g>
                    </svg>
                </>
            )
        
    }

    if (graphOptions == SEEDATA) {

       
        var brushX = brushLineChartX(height, width, id, xaxis, xScaleLinear, yaxis)
        var actualDataset = brushingDataset.getActualID(id)
                var predictionPoints
                if (histogramPredictionDataset.getPredictionLineChart(id + "_lineChart") == null) {
                    predictionPoints = histogramPredictionDataset.addPredictionLineChart(id + "_lineChart")
                }
                else {
                    predictionPoints = histogramPredictionDataset.getPredictionLineChart(id + "_lineChart")
                }

                actualDataset.setlinearYScale(linearYScale)
                var lineData = []
                
                var dateValues = Object.keys(categoriesMap)
                for (var i = 0; i < dateValues.length; i++) {
                    lineData.push([new Date(dateValues[i]).getFullYear(), categoriesMap[dateValues[i]]])
                }

                const line = d3.line()
                    .x(function(d) { return xScaleLinear(d[0]); })
                    .y(function(d) { return linearYScale(d[1]); });


                console.log('lineData', line(lineData), lineData)
                rectForeground = <path
                    fill={'none'}
                    d={line(lineData)}
                    stroke={REALDATA_COLOR}
                    strokeWidth={2}
                    className={id+"_line"}
                ></path>
                var predictionPathLineChart
                if (predictionPoints && predictionPoints.predictedPath) {
                    var linefn = d3.line<{ xValue: number; yValue: number; defined: boolean }>()
                        .defined(d => d.defined)
                        .x(function(d) { return xScaleLinear(d.xValue); })
                        .y(function(d) { return linearYScale(d.yValue); });
                    predictionPathLineChart = <path id={id + "_pre_line_path"} className={"your-line"} fill={'none'}
                        d={linefn(predictionPoints.predictedPath)}
                        stroke={PREDICTION_COLOR}
                        strokeWidth={2}
                        strokeDasharray={5} ></path>
                }

            
              

            return (
                <>
                    <svg
                        className={id + "chart"}
                        id={id + "_svg_barchart_draw"}
                        height={height + margin.left + margin.right}
                        width={width + margin.top + margin.bottom}
                    >
                        <g
                            transform={"translate(" + margin.left + ", " + margin.top + ")"}
                            id={id + "_svg_linechart"} className={id}
                        >
                            <g id={id+"brushX"} transform={"translate(0," + height + ")"}
                             ref={node => d3Select(node).call(brushX)}>
                                <g
                                    transform={"translate(0,0)"}
                                    ref={node => d3Select(node).call(xAxis)}
                                ></g>
                            </g>

                            <g ref={node => d3Select(node).call(yAxis) } className={"axisY"}></g>
                            {predictionPathLineChart}
                            {rectForeground}
                        </g>
                    </svg>
                </>
            );

            }

};
export default LineChart;

function timeparse(d) {
    return { date: d3.timeParse("%Y-%m-%d")(d.date), value: d.value }
}
function clamp(a, b, c) { return Math.max(a, Math.min(b, c)) }
function at(element, name, value) {
    if (typeof (name) == 'object') {
        for (var key in name) {
            element.attr(key.replace(/([a-z\d])([A-Z])/g, '$1-$2').toLowerCase(), name[key])
        }
        return element
    } else {
        return arguments.length == 1 ? element.attr(name) : element.attr(name, value)
    }
};

function f() {
    var functions = arguments

    //convert all string arguments into field accessors
    var i = 0, l = functions.length
    while (i < l) {
        if (typeof (functions[i]) === 'string' || typeof (functions[i]) === 'number') {
            functions[i] = (function(str) { return function(d) { return d[str] } })(functions[i])
        }
        i++
    }

    //return composition of functions
    return function(d) {
        var i = 0, l = functions.length
        while (i++ < l) d = functions[i - 1].call(this, d)
        return d
    }
}


function brushBar(xaxis, yaxis) {
  brushingDataset.getBrushingBarChartAxis().xaxis = xaxis;
  brushingDataset.getBrushingBarChartAxis().yaxis = yaxis;
}

function brushBarEmpty() {
  brushingDataset.emptyBrushingBarChartArray()
}


import {
    brush as d3brush,
    select as d3select,
    brushSelection as d3brushSelection
  } from "d3";


function brushLineChartX(height, width, id, xaxis, linearXScale, yaxis){
    var brushX = d3
    .brushX()
    .extent([[0, -height], [width, 16]])
    .on("start", function(e){
        

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        { 
            var eventlog = LogEvents.addEvent(id, LINE_CHART, SEEDATA, LOG_EVENT_TYPE_CHART_BRUSHING_STARTED,null, null,xaxis,yaxis,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

        if(BrushingDataSet.currentGraphID!=id)
          {
          clearAllBrushes()
          }
       
        }
       )
    .on("brush", function(d, i, j) {
      var brush_coords = d3brushSelection(this);
      if(brush_coords!=null)
      {
        var x0 = brush_coords[0];
        var x1 = brush_coords[1];
  
        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = LINE_CHART
        BrushingDataSet.currentGraphData = null
        BrushingDataSet.currentGraphEnable = 2
        BrushingDataSet.currentGraphBrushInstance = brushX
  
        lineChartBrush(2, id, null, brushingDataset);
      
        brushingDataset.getBrushingLineChartAxis().xaxis = xaxis;
        brushingDataset.getBrushingLineChartAxis().yaxis = "Count";
   
        brushingDataset.emptyBrushingLineChart()
        var brushingPointsLineChart= brushingDataset.getBrushingLineChart()
      
        brushingPointsLineChart.startX = linearXScale.invert(x0);
        brushingPointsLineChart.endX = linearXScale.invert(x1);
      
        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = LINE_CHART
        BrushingDataSet.currentGraphData = brushingPointsLineChart
        BrushingDataSet.currentGraphEnable = 0
        BrushingDataSet.currentGraphBrushInstance = brushX
  
        lineChartBrush(0, id, brushingPointsLineChart, brushingDataset);
      }
      
    })
    .on("end", function() {
      var brush_coords = d3brushSelection(this);
      if (brush_coords == null) {
        brushingDataset.emptyBrushingLineChart();

        var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
        if(logevents)
        { 
            var eventlog = LogEvents.addEvent(id, LINE_CHART, SEEDATA, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED,null, brush_coords,xaxis,yaxis,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
        }

        BrushingDataSet.currentGraphID = id
        BrushingDataSet.currentGraphType = LINE_CHART
        BrushingDataSet.currentGraphData = null
        BrushingDataSet.currentGraphEnable = 2
        BrushingDataSet.currentGraphBrushInstance = brushX

        lineChartBrush(2,id, null, brushingDataset);
      }
    });
    return brushX
}